const KM_DECIMALS = 1;

export const formatKmValue = (km: number): string => km.toFixed(KM_DECIMALS);

export const formatDayRouteKm = (routeKm: number): string =>
  routeKm > 0 ? `${formatKmValue(routeKm)} km approx.` : 'no route';
